<template>
  <div class="personal-area-clean content">
    <PersonalAreaNavBar :title="$t('personalArea.mainMenu')" backurl="main" />
    <PersonalAreaNoInternet />
    <div class="frame-3">
      <PersonalMainMenuRow
        @click="menuOpenIn('personal-area-privateinfo')"
        :title="$t('personalArea.personalInfo')"
      >
        <p>{{ $t("personalArea.mainPersonalMenu.asWeHaveIt") }}</p>
        <p>{{ $t("personalArea.mainPersonalMenu.changeInfoAlert") }}</p>
      </PersonalMainMenuRow>
      <PersonalMainMenuRow
        @click="menuOpenIn('personal-area-diskver')"
        :title="$t('personalArea.mainPersonalMenu.infoWeHave')"
      >
        <p>{{ $t("personalArea.mainPersonalMenu.infoMsg1") }}</p>
      </PersonalMainMenuRow>
      <PersonalMainMenuRow
        @click="menuOpenIn('personal-area-ext')"
        :title="$t('personalArea.extAndAdds')"
      >
        <p>{{ $t("personalArea.mainPersonalMenu.infoMsg2") }}</p>
      </PersonalMainMenuRow>
      <PersonalMainMenuRow
        @click="menuOpenIn('personal-area-convert-disk-online')"
        :title="$t('personalArea.mainPersonalMenu.infoMsg3')"
      >
        <p>{{ $t("personalArea.mainPersonalMenu.infoMsg4") }}</p>
      </PersonalMainMenuRow>
      <PersonalMainMenuRow
        v-if="$store.state.hasInternet"
        :title="$t('messages.myMessages')"
        @click="menuOpenIn('personal-area-messages')"
      >
        <p>{{ $t("personalArea.mainPersonalMenu.infoMsg7") }}</p>
      </PersonalMainMenuRow>
      <PersonalMainMenuRow
        :title="$t('mainMenu.contactName')"
        @click="menuOpenIn('personal-area-contact')"
      >
        <p>{{ $t("personalArea.mainPersonalMenu.infoMsg5") }}</p>
        <p>{{ $t("personalArea.mainPersonalMenu.infoMsg6") }}</p>
      </PersonalMainMenuRow>
    </div>
  </div>
</template>

<script>
import PersonalMainMenuRow from "./PersonalMainMenuRow.vue";
import PersonalAreaNoInternet from "./PersonalAreaNoInternet.vue";
import PersonalAreaNavBar from "./PersonalAreaNavBar.vue";
import menu from "@/services/menu";
export default {
  components: {
    PersonalMainMenuRow,
    PersonalAreaNoInternet,
    PersonalAreaNavBar,
  },
  methods: {
    menuOpenIn(loc) {
      menu.openAt(loc);
    },
  },
};
</script>

<style lang="scss" scoped>
.frame-3 {
  display: flex;
  width: 323px;

  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  background: #fff;
}
.content {
  display: flex;
  min-height: 718px;
  flex-direction: column;
  align-items: center;
  flex: 1 0 0;
  background: #fff;
}

.personal-area-clean * {
  margin: 0px;
}
</style>
